import { ReactElement } from 'react';
import PerformableGroupForm from '~/components/performable/PerformableGroupForm';
import Sections from '~/components/layout/Sections';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { McmDroneInclude, McmPhotoInclude } from '~/tenants/mcm/package/common';
import McmPhotoConfig, { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';

export default function McmPackageCrossroadsGoldForm(): ReactElement {
  return (
    <Sections>
      <TenantPackageIncludes>
        <McmPhotoInclude />
        <McmDroneInclude type={McmDroneType.VIDEO_PHOTO} />
      </TenantPackageIncludes>
      <PerformableGroupForm performable={McmPhotoConfig}>
        <ZodFieldHidden name="type" value={McmPhotoType.INTERIOR_EXTERIOR} />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmZillowConfig} />
      <PerformableGroupForm performable={McmDroneConfig}>
        <ZodFieldHidden name="type" value={McmDroneType.VIDEO_PHOTO} />
        <ZodFieldHidden name="daytime" value="true" />
      </PerformableGroupForm>
    </Sections>
  );
}
